
import React, { createContext, useContext, useState, useCallback } from 'react';

interface SidebarContextProps {
  collapsed: boolean;
  toggleCollapsed: () => void;
  collapsedWidth: number;
}

const SidebarContext = createContext<SidebarContextProps | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: React.ReactNode; collapsedWidth?: number }> = ({
  children,
  collapsedWidth = 64, // Default collapsed width (16 in Tailwind units, e.g., w-16)
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  return (
    <SidebarContext.Provider value={{ collapsed, toggleCollapsed, collapsedWidth }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
